var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-screen',{attrs:{"centralised":true},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('app-button',{attrs:{"text":"Continue"},on:{"click":_vm.onContinueClick}})]},proxy:true}])},[_c('div',{staticClass:"completed-text",domProps:{"innerHTML":_vm._s(_vm.texts.co.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }